import React from 'react';
import { AlertCard, AlertCardProps } from './cards';

export type AlertProps = AlertCardProps & {};

export const Alert: React.FC<AlertProps> = (props) => {
  return <AlertCard {...props} />;
};
